import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_371: DocMigration = {
  maxSchemaVersion: "0.0.371",
  description: "Remove selected field from doc intended for editor",
  apply(json: any) {
    delete json.selected;
    return json;
  },
};

export default migration_0_0_371;
